export default __webpack_public_path__ + "static/media/cat-image.969a47a3.jpg";